import { Feature, TrackingLabels } from "../../types/Tracking";
import { resolveLinkType } from "../ProductTileClickHandling";
import Slider from "./Slider";

export default class BrandSlider extends Slider {
  protected type = "BRAND";
  private typeBlackFriday = "BRAND_BLACK_FRIDAY";

  protected getPathSegment() {
    return "brand-slider";
  }

  protected isType(type: string | undefined) {
    return this.type === type || type === this.typeBlackFriday;
  }

  protected getClickTrackingLabel(position: number, ev: MouseEvent): TrackingLabels {
    if (this.avContent) {
      return {
        san_Interaction: "brand_slider_product_tile",
        "wk.san_ProductClickListType": this.avContent.dataset.pt,
        "wk.san_ProductLinkType": resolveLinkType(ev),
        "wk.san_ProductType": "brand_slider",
        "wk.san_SliderPosition": +position,
      };
    }

    return {};
  }

  protected prepareFeatureTracking(currentSlides: number[], baseTrackingLabels: TrackingLabels): Feature[] {
    return [
      <Feature>{
        id: "san_brand_slider",
        name: "Brand-Slider",
        status: "loaded",
        labels: baseTrackingLabels,
      },
    ].concat(
      currentSlides.map((index) => {
        const tile: HTMLElement = document.getElementsByClassName(this.sliderItemClassName).item(index) as HTMLElement;
        const position = tile.dataset.position || "";
        const variationCount = tile.dataset.variationCount || "";
        return <Feature>{
          id: "san_brand_tile_" + position,
          name: "Brand-Slider-Tile",
          status: "loaded",
          parentId: "san_brand_slider",
          position: +position,
          variationId: tile.dataset.variationId,
          labels: {
            san_ProductType: "brand_slider",
            san_VariationCount: +variationCount,
          },
        };
      }),
    );
  }
}
